import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectLanguage, selectLanguages,appActions, selectShowTranslationsKeys, selectCanShowTranslationsKeys } from '../../redux/appSlice';
import styles from './Header.module.scss';
import { Button, Divider, Menu, Switch } from '@mantine/core';
import logo from '../../assets/images/logo.png'
import { ChevronDown } from '../icons/Icons';
import useStyles from '../../hooks/useStyles';
import { LanguageData } from '../../redux/types';
import { store } from '../../redux/store';
import { loadTranslations } from '../../services/api';
import useTranslation from '../../hooks/useTranslation';

type Props = {
  contactFormHeader: boolean,
  headerLabel?: string,
  children?: React.ReactNode,
}

function Header({ contactFormHeader, headerLabel='', children }: Props) {
  const { classes } = useStyles();

  const dispatch = useDispatch()

  const languages = useSelector( selectLanguages ) || []
  const currentLanguageCode = useSelector( selectLanguage ) || ''
  const showKeys = useSelector( selectShowTranslationsKeys)
  const canUseSwitch = useSelector( selectCanShowTranslationsKeys)
  const t = useTranslation()

  const currentLanguage = languages.find( (item:LanguageData )=> item.code === currentLanguageCode )

  const setLanguage = (code:string) => {
    dispatch(appActions.setLanguage(code))
    loadTranslations(store, code).then((data) => {
      dispatch(appActions.setTranslation(data))
    })
  } 

  const changeKeysState = () => {
    if(showKeys) {
      dispatch(appActions.setShowTranslationsKeysState(false))
    } else {
      dispatch(appActions.setShowTranslationsKeysState(true))
    }
  }

  return (
    <div className={styles.Header}>
      <div className={styles.appName}>{contactFormHeader ?t(headerLabel) :t('ui-header-title')}</div>
      <div><img src={logo} className={styles.logo} /></div>
      <div className={styles.actions}>
        { canUseSwitch && <Switch label={t('ui-general-show-keys')} className={classes.switchBox} onChange={ () => changeKeysState() } />}
        <Menu control={<Button variant="subtle" rightIcon={<ChevronDown />}
            className={classes.subtleAction}>{currentLanguage && currentLanguage.language}</Button>} placement="end">
          <Menu.Item disabled={true}>{currentLanguage && currentLanguage.language}</Menu.Item>
          <Divider />
          {languages.map((item:LanguageData, index:number) => (
            <Menu.Item key={index} onClick={(e:any) => setLanguage(item.code)} value={item.code}>{item.language}</Menu.Item>
          ))}
        </Menu>
      </div>
    </div>
  );
}

export default Header;
